<div class="bg-dialog-header" mat-dialog-title color="primary">
  <div class="flex flex-row justify-between items-center text-white w-full select-none">
    <div>{{data.field.displayName}}</div>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<div class="flex flex-col" mat-dialog-content>
  <ng-template cdwAeMatcherEditor></ng-template>
</div>
<div class="flex row justify-between button-action-bar">
  <button mat-flat-button mat-dialog-close>Close</button>
  <button data-testid="apply-button" mat-flat-button (click)="close()" [disabled]="!hasValidMatcherData || isValidating">{{ isValidating ? 'Validating…' : 'Apply' }}</button>
</div>
